import { configureStore } from '@reduxjs/toolkit';
import auth from './auth';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAtW_qBMUCBBs-5TKRjLm4XEt2-FoIqhXM",
    authDomain: "readingtracker-app.firebaseapp.com",
    projectId: "readingtracker-app",
    storageBucket: "readingtracker-app.appspot.com",
    messagingSenderId: "588886848765",
    appId: "1:588886848765:web:79b89f6ac84d1c65b1fa94",
    measurementId: "G-5GS18B0DNB"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

const store = configureStore({
    reducer: { auth: auth.reducer },
});

// Can still subscribe to the store
store.subscribe(() => console.log(store.getState()));

getAuth().onAuthStateChanged(user => {
    if (user) {
        user.getIdToken().then(token => {
            store.dispatch(auth.actions.authReady({ userInfo: { name: user.displayName }, token }));
        });
    } else {
        store.dispatch(auth.actions.authReady({ userInfo: null, token: null }));
    }
});

export { store, auth };
